export const WorkoutPlayerFinished = {
  bindings: {
    workout: '<',
    member: '<',
    voomeProductId: '<',
  },

  template: `
    <div class="workout-player-finished">
      <h4 class="workout-player-finished-title text-center my-3">
        <i class="fa fa-check-circle-o"></i>
        Workout Done!
      </h4>
      <div class="workout-player-summary">
        <span class="workout-player-summary-img"></span>
        <div class="workout-player-summary-content">
          <h2 class="workout-player-summary-title">
            {{ $ctrl.workout.name }}
          </h2>
          <ul class="workout-player-summary-meta list-inline">
            <li>
              <i class="fa icon-calories-burnt"></i>
              <workout-calories-burnt
                member="$ctrl.member"
                met="$ctrl.workout.met"
                total-time="$ctrl.workout.totalTime">
              </workout-calories-burnt> Cal
            </li>
            <li ng-if="$ctrl.workout.totalTimeVerbose">
              <i class="fa icon-time"></i>
              {{ $ctrl.workout.totalTimeVerbose }}
            </li>
          </ul>
        </div>
      </div>
      <div class="workout-player-footer">
        <div class="workout-player-caption px-4">
          <a class="back-btn"
            ui-sref="program({ voomeProductId: $ctrl.voomeProductId })">
            <i class="fa fa-home"></i> Home
          </a>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerFinished.js